import { trackDataLayerEvent } from "./dataLayer"

// Meiro CDP `forms` event — see app/services/FormTracking.php for the server-side stages

const EVENT_NAME = "forms"
const FORM_SELECTOR = "form[data-form-tracking]"
const COOKIE_NAME = "acc_form_events"
const VIEW_THRESHOLD = 0.5

const trackedOnce = new Set()

export default function initFormTracking() {
  const observer = new IntersectionObserver(
    (entries) => {
      entries
        .filter((entry) => entry.isIntersecting)
        .forEach((entry) => trackOnce(entry.target, { action: "view" }))
    },
    { threshold: VIEW_THRESHOLD }
  )

  const observeForms = () =>
    document
      .querySelectorAll(FORM_SELECTOR)
      .forEach((form) => observer.observe(form))

  observeForms()
  // Snippet redraws replace the <form> element
  document.addEventListener("ajaxSnippetUpdate", observeForms)

  document.addEventListener("input", (event) => {
    const form = event.target.closest?.(FORM_SELECTOR)
    if (form) trackOnce(form, { form_action: "started" })
  })

  document.addEventListener("click", (event) => {
    const cta = event.target.closest?.("[data-form-cta]")
    if (!cta) return

    const form = document.querySelector(
      `${cta.dataset.formCta} ${FORM_SELECTOR}`
    )
    if (form) track(form, { action: "cta_clicked" })
  })
}

// Submitted / error / confirmed events come from the server in a short-lived cookie
export function sendStoredFormEvents() {
  const match = document.cookie.match(
    new RegExp(`(?:^|; )${COOKIE_NAME}=([^;]+)`)
  )
  if (!match) return

  document.cookie = `${COOKIE_NAME}=; Path=/; Max-Age=0`

  try {
    const events = JSON.parse(decodeURIComponent(match[1]))
    events.forEach((payload) => trackDataLayerEvent(EVENT_NAME, false, payload))
  } catch {
    // malformed cookie, nothing to send
  }
}

function trackOnce(form, stage) {
  const key = `${Object.values(stage)[0]}:${form.dataset.formTracking}`
  if (trackedOnce.has(key)) return

  trackedOnce.add(key)
  track(form, stage)
}

function track(form, stage) {
  let formData
  try {
    formData = JSON.parse(form.dataset.formTracking)
  } catch {
    return
  }

  trackDataLayerEvent(EVENT_NAME, false, {
    ...formData,
    ...stage,
    location: window.location.origin + window.location.pathname,
  })
}
